import React from "react";
import { connect } from "react-redux";
import { PortalWithState } from "react-portal";

import { ChromePicker } from "react-color";
import {
	setPresetName,
	setPrimaryColor,
	setSecondaryColor
} from "../../actions/";

import WizardStep from "../WizardStep";
import WizardSidebar from "../WizardSidebar";
import colorPresets from "../../config/colorPresets";
import "../../css/Palette.scss";

class Palette extends React.Component {
	primaryColorPickerRef = React.createRef();
	secondaryColorPickerRef = React.createRef();

	state = {
		title: "Choose your colors",
		text:
			"Loyalty has to look good, too. Using your brand colors will make your program pop.",
		presets: colorPresets,
		selectedPresetName: "preset5",
		showPrimaryColorPicker: false,
		showSecondaryColorPicker: false,
		initialPrimaryColor: "#9A249A",
		initialSecondaryColor: "#90B3C7"
	};

	componentWillMount = () => {
		// Set primary preset when component renders
		if (Object.keys(this.props.palette).length === 0) {
			this.props.setPresetName("preset1");
			this.props.setPrimaryColor("#FC3B3D");
			this.props.setSecondaryColor("#003D73");
		}
	};

	selectPreset = preset => {
		this.props.setPresetName(preset.presetName);
		this.props.setPrimaryColor(preset.primaryColor);
		this.props.setSecondaryColor(preset.secondaryColor);
	};

	/**
	 * Set custom preset colors
	 */

	setCustomPreset = (colorName, hex) => {
		this.props.setPresetName("customPreset");

		// eslint-disable-next-line default-case
		switch (colorName) {
			case "primary": {
				this.props.setPrimaryColor(hex);
				this.setState({
					initialPrimaryColor: hex
				});
				break;
			}
			case "secondary": {
				this.props.setSecondaryColor(hex);
				this.setState({
					initialSecondaryColor: hex
				});
				break;
			}
		}
	};

	changeColorOption = option => {
		if (option === "customPreset") {
			this.setCustomPreset("primary", this.state.initialPrimaryColor);
			this.setCustomPreset("secondary", this.state.initialSecondaryColor);
		}

		if (option === "presets") {
			this.selectPreset({
				presetName: "preset1",
				primaryColor: "#FC3B3D",
				secondaryColor: "#003D73"
			});
		}
	};

	renderPresetList = () => {
		return this.state.presets.map(preset => {
			return (
				<div
					className={
						"single-preset " +
						(this.props.palette.presetName === preset.presetName ||
						(this.props.palette.length === 0 &&
							this.state.selectedPresetName === preset.presetName)
							? "selected"
							: "")
						// If prop is set, show 'selected' button state,
						// If prop is empty - use the preset from the component state
					}
					key={preset.presetName}
					onClick={() => {
						this.selectPreset(preset);
					}}>
					<div
						className="color primary-color"
						style={{ backgroundColor: preset.primaryColor }}
					/>
					<div
						className="color secondary-color"
						style={{ backgroundColor: preset.secondaryColor }}
					/>
				</div>
			);
		});
	};

	render() {
		return (
			<div className="view palette">
				<WizardSidebar
					title="The customer-brand relationship"
					text={
						<div>
							<p>
								Today, customers are becoming increasingly brand loyal across
								industries.
							</p>
							<p>
								Competition for consumer attention is sky-high, but customers
								are more brand loyal than ever before: 90.2% consider themselves
								equally or more devoted to their favorite companies compared to
								a year ago.
							</p>
						</div>
					}
					image="step-2"
				/>
				<WizardStep
					title={this.state.title}
					text={this.state.text}
					navigateTo="goals"
					buttonText="Next"
					actionType="Palette"
					disabledButton={this.props.palette ? "" : "disabled"}>
					<div className="palette-configurator">
						<div className="color-selection">
							<div className="select-preset">
								<div
									className={
										"radio-button-wrapper " +
										(this.props.palette.presetName !== "customPreset"
											? "active"
											: "")
									}
									onClick={() => {
										this.changeColorOption("presets");
									}}>
									<div className="radio-button">
										<span />
									</div>
									<div className="radio-label">
										Pick the colors that fit your brand
									</div>
								</div>

								<div className="preset-picker">{this.renderPresetList()}</div>
							</div>
							<div className="customize-preset">
								<div
									className={
										"radio-button-wrapper " +
										(this.props.palette.presetName === "customPreset"
											? "active"
											: "")
									}
									onClick={() => {
										this.changeColorOption("customPreset");
									}}>
									<div className="radio-button">
										<span />
									</div>
									<div className="radio-label">Or choose your own</div>
								</div>
								<div className="color-pickers">
									<div
										className={
											"primary-color-picker picker " +
											(this.state.showPrimaryColorPicker ? "selected" : "")
										}
										onClick={() => {
											if (this.state.selectedPresetName !== "customPreset") {
												this.changeColorOption("customPreset");
											}
										}}>
										<div className="edit-color-icon" />
										<PortalWithState
											node={this.primaryColorPickerRef.current}
											closeOnOutsideClick
											closeOnEsc>
											{({ openPortal, closePortal, isOpen, portal }) => (
												<React.Fragment>
													<div
														className={
															"picker-color " + (isOpen ? "selected" : "")
														}
														ref={this.primaryColorPickerRef}
														style={{
															backgroundColor:
																this.props.palette.presetName === "customPreset"
																	? this.props.palette.primaryColor
																	: this.state.initialPrimaryColor
														}}
														onClick={openPortal}
													/>
													{portal(
														<React.Fragment>
															<div className="mask" onClick={closePortal} />
															<ChromePicker
																onChangeComplete={e =>
																	this.setCustomPreset("primary", e.hex)
																}
																color={this.props.palette.primaryColor}
																disableAlpha={true}
															/>
														</React.Fragment>
													)}
												</React.Fragment>
											)}
										</PortalWithState>
									</div>
									<div
										className={
											"secondary-color-picker picker " +
											(this.state.showSecondaryColorPicker ? "selected" : "")
										}
										onClick={() => {
											if (this.state.selectedPresetName !== "customPreset") {
												this.changeColorOption("customPreset");
											}
										}}>
										<div className="edit-color-icon" />
										<PortalWithState
											node={this.secondaryColorPickerRef.current}
											closeOnOutsideClick
											closeOnEsc>
											{({ openPortal, closePortal, isOpen, portal }) => (
												<React.Fragment>
													<div
														className={
															"picker-color " + (isOpen ? "selected" : "")
														}
														ref={this.secondaryColorPickerRef}
														style={{
															backgroundColor:
																this.props.palette.presetName === "customPreset"
																	? this.props.palette.secondaryColor
																	: this.state.initialSecondaryColor
														}}
														onClick={openPortal}
													/>
													{portal(
														<React.Fragment>
															<div className="mask" onClick={closePortal} />
															<ChromePicker
																onChangeComplete={e =>
																	this.setCustomPreset("secondary", e.hex)
																}
																color={this.props.palette.secondaryColor}
																disableAlpha={true}
															/>
														</React.Fragment>
													)}
												</React.Fragment>
											)}
										</PortalWithState>
									</div>
								</div>
							</div>
						</div>
						<div className="color-selection-preview">
							<div className="preview-title">Preview</div>
							<div className="preview-image">
								<div className="browser-bar">
									<div
										className="circle secondary-color"
										style={{
											backgroundColor: this.props.palette.secondaryColor
										}}
									/>
									<div
										className="circle secondary-color"
										style={{
											backgroundColor: this.props.palette.secondaryColor
										}}
									/>
									<div
										className="circle secondary-color"
										style={{
											backgroundColor: this.props.palette.secondaryColor
										}}
									/>
								</div>
								<div
									className="secondary-color hero"
									style={{
										backgroundColor: this.props.palette.secondaryColor
									}}>
									<div
										className="primary-color big-circle"
										style={{
											backgroundColor: this.props.palette.primaryColor
										}}
									/>
								</div>
								<div className="image-example">
									<div
										className="primary-color left-side"
										style={{
											backgroundColor: this.props.palette.primaryColor
										}}
									/>
									<div className="right-side">
										<div
											className="triangle primary-color"
											style={{
												borderColor: `${
													this.props.palette.primaryColor
												} transparent transparent transparent`
											}}
										/>
										<svg
											width="34px"
											height="34px"
											viewBox="0 0 34 34"
											version="1.1"
											xmlns="http://www.w3.org/2000/svg">
											<g
												id="Page-1"
												stroke="none"
												strokeWidth="1"
												fill="none"
												fillRule="evenodd">
												<g
													id="Group"
													style={{ mixBlendMode: "multiply" }}
													fill={this.props.palette.primaryColor}>
													<polygon
														id="Path"
														points="15.466 20.479 11.136 17.49 7.083 25.5 26.917 25.486 20.957 9.916"
													/>
													<path
														d="M12.041,9.917 C13.215,9.917 14.166,10.867 14.166,12.042 C14.166,13.216 13.215,14.167 12.041,14.167 C10.868,14.167 9.917,13.216 9.917,12.042 C9.917,10.867 10.868,9.917 12.041,9.917 Z"
														id="Path"
													/>
													<path
														d="M29.751,4.25 L29.749,4.251 L29.751,29.75 L4.25,29.75 L4.25,4.25 L29.751,4.25 Z M29.751,0 L4.25,0 C1.902,0 0,1.902 0,4.251 L0,29.75 C0,32.096 1.902,34 4.25,34 L29.751,34 C32.098,34 34,32.096 34,29.75 L34,4.251 C34,1.902 32.098,0 29.751,0 Z"
														id="Shape"
														fillRule="nonzero"
													/>
												</g>
											</g>
										</svg>
									</div>
								</div>
								<div
									className="reward-list-container primary-color"
									style={{
										backgroundColor: this.props.palette.primaryColor
									}}>
									<div
										className="big-circle secondary-color"
										style={{
											backgroundColor: this.props.palette.secondaryColor
										}}
									/>

									<div className="reward-list">
										<div className="reward">
											<div
												className="small-circle secondary-color"
												style={{
													backgroundColor: this.props.palette.secondaryColor
												}}
											/>
										</div>
										<div className="reward">
											<div
												className="small-circle secondary-color"
												style={{
													backgroundColor: this.props.palette.secondaryColor
												}}
											/>
										</div>
										<div className="reward">
											<div
												className="small-circle secondary-color"
												style={{
													backgroundColor: this.props.palette.secondaryColor
												}}
											/>
										</div>
									</div>
								</div>
								<div
									className="big-circle secondary-color"
									style={{
										backgroundColor: this.props.palette.secondaryColor
									}}
								/>
							</div>
						</div>
					</div>
				</WizardStep>
			</div>
		);
	}
}

const mapStateToProps = state => {
	return {
		palette: state.palette
	};
};

export default connect(
	mapStateToProps,
	{ setPresetName, setPrimaryColor, setSecondaryColor }
)(Palette);
